export const getEditLocationPath = (id: string) => `/locations/edit/${id}/`;
export const getCloneLocationPath = (id: string) => `/locations/clone/${id}/`;

export const ADD_LOCATION_PATH = '/locations/add/';
export const LOCATION_DETAILS_PATH = 'details';
export const LOCATION_CONFIG_PATH = 'configuration';
export const LANES_PATH = 'lanes';
export const MANEUVERS_PATH = 'maneuvers';
export const CROSSWALKS_PATH = 'crosswalks';

export const DEFAULT_ZOOM_LEVEL = 16;

export const LANES_FORM_ID = 'lanes';
export const CROSSWALKS_FORM_ID = 'crosswalks';
export const MANEUVERS_FORM_ID = 'maneuvers';

export const POINT_LOCATION_TYPES = ['Intersection', 'Ramp'];

export const DEFAULT_POLYGON_COLOR = '#ff0000';
export const DEFAULT_POLYGON_OPACITY = 0.5;

export const DEFAULT_SEGMENT_COLOR = '#ff6900';
export const DEFAULT_SEGMENT_OPACITY = 0.5;
